var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#38AD4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4456 6.25506C13.6184 6.08965 13.8483 5.99821 14.0869 6.00003C14.3255 6.00184 14.5541 6.09677 14.7244 6.26478C14.8947 6.4328 14.9934 6.66075 14.9997 6.90055C15.006 7.14034 14.9194 7.37323 14.7582 7.55005L9.86357 13.7044C9.7794 13.7955 9.67782 13.8686 9.5649 13.9194C9.45198 13.9702 9.33003 13.9975 9.20636 13.9998C9.08268 14.0021 8.95981 13.9793 8.8451 13.9328C8.73038 13.8863 8.62618 13.817 8.53872 13.729L5.29283 10.4656C5.20243 10.381 5.12993 10.2788 5.07965 10.1654C5.02936 10.0519 5.00232 9.92942 5.00014 9.80522C4.99796 9.68102 5.02069 9.55765 5.06696 9.44248C5.11323 9.3273 5.18211 9.22267 5.26947 9.13483C5.35684 9.047 5.4609 8.97775 5.57547 8.93123C5.69003 8.88471 5.81273 8.86186 5.93627 8.86405C6.0598 8.86624 6.18163 8.89343 6.29449 8.94398C6.40734 8.99454 6.50892 9.06743 6.59315 9.15831L9.16189 11.7397L13.4223 6.28219L13.4456 6.25506Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.28e0347c212e5b57adc132888924fa37.svg";
export { ForwardRef as ReactComponent };